// src/lib/app-base-url.js — Lot INFRA 2.1 PR-A (liens propres)
//
// Résolution CLIENT du domaine canonique de l'app (pages publiques voyageur :
// livret, formulaire /bienvenue, QR PDF).
//
// BUG LATENT corrigé ici : l'ancien code client lisait FBZ_PUBLIC_BASE_URL /
// FBZ_APP_BASE_URL — variables SANS préfixe REACT_APP_, donc JAMAIS inlinées
// par CRA (DefinePlugin ne whiteliste que NODE_ENV + REACT_APP_*). Le fallback
// dur `https://fullbnbzen.vercel.app` était donc TOUJOURS actif en prod côté
// navigateur.
//
// Priorité :
//   1. REACT_APP_FBZ_APP_BASE_URL (inlinée au build CRA — à poser en Vercel,
//      redeploy SANS cache) ;
//   2. dev local : origin du navigateur (http://localhost:3000) ;
//   3. fallback dur https://sejour.fullbnbzen.com — le domaine canonique est
//      stable, mieux qu'une variable jamais posée (≠ ancien vercel.app).
//
// ⚠️ NE PAS lire VERCEL_URL ni window.location.origin en prod : URL deployment-
// specific / preview → 401 Vercel + X-Frame-Options:DENY (bug prod 2026-05-16).
//
// Fichier volontairement en CommonJS : consommé par les modules ESM src/ via
// interop babel/webpack, ET requirable en Node nu (preuve `node -e`).

const CANONICAL_APP_BASE_URL = "https://sejour.fullbnbzen.com";

function resolveAppBaseUrl() {
  const envBase = process.env.REACT_APP_FBZ_APP_BASE_URL;
  if (envBase && String(envBase).trim()) {
    return String(envBase).trim().replace(/\/+$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return typeof window !== "undefined" && window.location
      ? window.location.origin
      : "http://localhost:3000";
  }
  return CANONICAL_APP_BASE_URL;
}

module.exports = { resolveAppBaseUrl, CANONICAL_APP_BASE_URL };
